// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GridContainer_container__rHCZ2 {
  display: grid;
  justify-content: left;
}`, "",{"version":3,"sources":["webpack://./src/components/common/GridContainer/GridContainer.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,qBAAA;AACJ","sourcesContent":[".container {\n    display: grid;\n    justify-content: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GridContainer_container__rHCZ2`
};
export default ___CSS_LOADER_EXPORT___;
